import { EntityEmptyState } from '@pesto/features/src/EntityProfile/components/EntityEmptyState';
import { LinkedEntityCard } from '@pesto/features/src/EntityProfile/components/LinkedEntityCard';
import { User, Users } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import type { LoanUserListItem } from '../toLoanDetail';

import { routes } from '../../../constants/routes';

interface LoanUsersTabProps {
  users: LoanUserListItem[];
}

const buildName = (user: LoanUserListItem): string =>
  [user.firstName, user.middleName, user.lastName].filter(Boolean).join(' ').trim() || '—';

export const LoanUsersTab = ({ users }: LoanUsersTabProps) => {
  const navigate = useNavigate();

  if (users.length === 0) {
    return <EntityEmptyState icon={Users} title="This loan has no attached users." />;
  }

  return (
    <div className="space-y-2">
      {users.map((user) => (
        <LinkedEntityCard
          key={user.id}
          icon={User}
          title={buildName(user)}
          subtitle={user.email}
          onClick={() => navigate(routes.users + '/' + user.id)}
        />
      ))}
    </div>
  );
};
